const mutations = {
    componentsData: (state, { data }) => {
        state.Detailsdata = data.Detailsdata
        state.FDataLayoutInfo = data.FDataLayoutInfo
        state.SelectedRow = data.SelectedRow
        browseRecord = data.browseRecord
    },
    setBrData: (state, data) => {
        //设置当前页面的brData
        for (let index = 0; index < state.browseRecord.length; index++) {
            var element = state.browseRecord[index];
            if (element.key == data.currentpath) {
                element.brData = null;
                element.brData = data.brData
            }
        }
    },
    setBillOpState: (state, data) => {
        //设置当前页面的BillOpState

        for (let index = 0; index < state.browseRecord.length; index++) {
            var element = state.browseRecord[index];
            if (element.key == data.currentpath) {
                element.BillOpState = null;
                element.BillOpState = data.BillOpState
            }
        }
    },
    setBeforeOpState: (state, data) => {
        //设置当前页面的BeforeOpState

        for (let index = 0; index < state.browseRecord.length; index++) {
            var element = state.browseRecord[index];
            if (element.key == data.currentpath) {
                element.BeforeOpState = null;
                element.BeforeOpState = data.BeforeOpState
            }
        }
    },
    setBrowseRecord: (state, data) => {
        //设置页签
        state.browseRecord.push(data)
    },
    setisOpenRouter: (state, data) => {
        state.isOpenRouter = data
    },
    setisCloseRouter: (state, data) => {
        state.isCloseRouter = data
    },
    //设置最近使用
    setRecentList: (state, data) => {
        state.recentListArr = data
    },
    //设置collapse 开关
    setCollapse: (state, data) => {
        state.isCollapse = data
    },
    //设置入库明细刷新状态
    setRkmxState: (state, data) => {
        state.rkmxState = data
    },
    //替换Logo图片
    setLogoPic: (state, data) => {
        state.logoPic = data
    },
}

export default mutations;